var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFolderIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 12,
    viewBox: "0 0 15 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8333 1.99999H7.49998L6.16665 0.666656H2.16665C1.42665 0.666656 0.83998 1.25999 0.83998 1.99999L0.833313 9.99999C0.833313 10.74 1.42665 11.3333 2.16665 11.3333H12.8333C13.5733 11.3333 14.1666 10.74 14.1666 9.99999V3.33332C14.1666 2.59332 13.5733 1.99999 12.8333 1.99999ZM12.8333 9.99999H2.16665V1.99999H5.61331L6.94665 3.33332H12.8333V9.99999ZM7.49998 7.33332H8.83331V8.66666H10.1666V7.33332H11.5V5.99999H10.1666V4.66666H8.83331V5.99999H7.49998V7.33332Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderIcon);
export default __webpack_public_path__ + "static/media/folder-icon.3ea559cb51132b33d420f4044f28b16c.svg";
export { ForwardRef as ReactComponent };